import { QGL_Lib } from "./QGL_Lib";
import { Mat_SamletFastEjendom, Bbr_Ejendomsrelation } from "./DFQGLTypes";

export class BBRQGL_Lib extends QGL_Lib {




  async TeknikPåGrunde(sfeNr: string): Promise<{ BBR_Ejendomsrelation: { nodes: any[] } }> {
    let isoNow = new Date().toISOString();
    return this.query<{ BBR_Ejendomsrelation: { nodes: any[] } }>(`
query {BBR_Ejendomsrelation(
registreringstid: "2025-12-20T13:31:33z"
virkningstid: "2025-12-20T13:31:33z"
where: { bfeNummer: { eq: 100073729 } }
) {nodes {grundSamletFastEjendom {nodes {
grundTekniskAnlaeg {nodes {
${BBR_TeknikListe()}
}}}}}}}
`
    )
  }

  async TeknikIBygninger(sfeNr: string): Promise<{ MAT_SamletFastEjendom: { nodes: Pick<Mat_SamletFastEjendom, "BFEnummer_18_Ejendomsrelation_bfeNummer_ref" | "BFEnummer" | "status">[] } }> {
    let isoNow = new Date().toISOString();
    return this.query<{ MAT_SamletFastEjendom: { nodes: any[] } }>(`
query {BBR_Ejendomsrelation(
registreringstid: "2025-12-20T13:31:33z"
virkningstid: "2025-12-20T13:31:33z"
where: { bfeNummer: { eq: 100073729 } }
) {nodes {grundSamletFastEjendom {nodes {
grundTekniskAnlaeg {nodes {
${BBR_TeknikListe()}
}}}}}}}
`);
  }

  async TeknikIEnheder(sfeNr: string): Promise<{ MAT_SamletFastEjendom: { nodes: Pick<Mat_SamletFastEjendom, "BFEnummer_18_Ejendomsrelation_bfeNummer_ref" | "BFEnummer" | "status">[] } }> {
    let isoNow = new Date().toISOString();
    return this.query<{ MAT_SamletFastEjendom: { nodes: any[] } }>(`
      query {BBR_Ejendomsrelation(
registreringstid: "2025-12-20T13:31:33z"
virkningstid: "2025-12-20T13:31:33z"
where: { bfeNummer: { eq: 100073729 } }
) {nodes {grundSamletFastEjendom {nodes {
grundTekniskAnlaeg {nodes {
${BBR_TeknikListe()}
}}}}}}}
`);
  }


  async BBRRelation(bfeNr: string[]): Promise<{ BBR_Ejendomsrelation: { nodes: Bbr_Ejendomsrelation[] } }> {
    let isoNow = new Date().toISOString();
    return this.query<{ BBR_Ejendomsrelation: { nodes: any[] } }>(`
      query {
  BBR_Ejendomsrelation(
    virkningstid: "${isoNow}"
    registreringstid: "${isoNow}"
    where: { bfeNummer: { in: [ ${bfeNr.join(", ")} ] } }
  ) {
    nodes {
      status
      ejendomstype
      ejendomsnummer
      bfeNummer
      bygningPaaFremmedGrund
      ejerlejlighedsnummer
      ejendomsrelationEjerlejlighed {nodes{
      	enhedEjerlejlighed {enh026EnhedensSamledeAreal}
      }}
      ejendomsrelationBygningPaaFremmedGrund {nodes{
        bygningBygningPaaFremmedGrund {
          byg038SamletBygningsareal
        }
      }}
      bygningEjerlejlighed { nodes {
        byg038SamletBygningsareal
        ejerlejlighed
      }
      }
      grundSamletFastEjendom {
      	nodes { 
        	bygningGrund {nodes {
            byg038SamletBygningsareal
          }}
        }
      }
    }
  }
}`


    )
  }

  async BygOgEnheder(sfeNr: string): Promise<{ MAT_SamletFastEjendom: { nodes: Pick<Mat_SamletFastEjendom, "BFEnummer_18_Ejendomsrelation_bfeNummer_ref" | "BFEnummer" | "status">[] } }> {
    let isoNow = new Date().toISOString();
    return this.query<{ MAT_SamletFastEjendom: { nodes: any[] } }>(`
query {
      MAT_SamletFastEjendom(
        virkningstid: "${isoNow}"
    registreringstid: "${isoNow}" 
    where: { BFEnummer: { eq: ${sfeNr} } status: { eq: "Gældende" }}
  ) {
    nodes {
    id_lokalId
    objectid
    BFEnummer
    registreringFra
    registreringTil
    virkningFra
    virkningTil
    status
      BFEnummer_18_Ejendomsrelation_bfeNummer_ref {
        nodes {
          grundSamletFastEjendom {nodes {
          id_lokalId
          status
          gru009Vandforsyning
          gru010Afloebsforhold
          gru021Udledningstilladelse
          gru025TilladelseTilUdtraeden
          gru024FristVedrSpildevandsafledning
          gru026DatoForTilladelseTilUdtraeden
          gru023PaabudVedrSpildevandsafledning
          gru022MedlemskabAfSpildevandsforsyning
          gru029DispensationFritagelseIftKollektivVarmeforsyning
          gru027TilladelseTilAlternativBortskaffelseEllerAfledning
            grundTekniskAnlaeg {nodes {${BBR_TeknikListe()} } }
            bygningGrund {nodes {
            byg007Bygningsnummer
            id_lokalId
            status
            byg026Opfoerelsesaar
            byg021BygningensAnvendelse
            byg039BygningensSamledeBoligAreal
            byg040BygningensSamledeErhvervsAreal
            byg041BebyggetAreal
            byg038SamletBygningsareal
            byg054AntalEtager
              bygningEtage {nodes {
              eta025Etagetype
              eta022Kaelderareal
              eta026ErhvervIKaelder
              eta020SamletArealAfEtage
              eta024EtagensAdgangsareal
              eta006BygningensEtagebetegnelse
              eta021ArealAfUdnyttetDelAfTagetage
              eta023ArealAfLovligBeboelseIKaelder
            }
            }
              bygningTekniskAnlaeg {nodes {${BBR_TeknikListe()} } }
              liggerIBygning {nodes {
                enhedTekniskAnlaeg { nodes {${BBR_TeknikListe()} } }
              id_lokalId
              enh020EnhedensAnvendelse
              enh023Boligtype
              enh026EnhedensSamledeAreal
              enh027ArealTilBeboelse
              enh028ArealTilErhverv
              enh031AntalVaerelser
              enh066AntalBadevaerelser
              enh065AntalVandskylledeToiletter
            }
            }
          }
          }
        }
        }
      }
    }
  }
}
}
`);
  }
}

function BBR_TeknikListe(): string {
  return `
id_lokalId
tek007Anlaegsnummer
status
tek020Klassifikation
tek021FabrikatType
tek022EksternDatabase
tek023EksternNoegle
tek024Etableringsaar
tek025TilOmbygningsaar
tek026StoerrelsesklasseOlietank
tek027Placering
tek028SloejfningOlietank
tek030Fabrikationsnummer
tek031Typegodkendelsesnummer
tek032Stoerrelse
tek033Type
tek034IndholdOlietank
tek035SloejfningsfristOlietank
tek036Rumfang
tek037Areal
tek038Hoejde
tek039Effekt
tek040Fredning
tek042Revisionsdato
tek045Koordinatsystem
tek067Fabrikationsaar
tek068Materiale
tek069SupplerendeIndvendigKorrosionsbeskyttelse
tek072Sloejfningsaar
tek073Navhoejde
tek074Vindmoellenummer
tek075Rotordiameter
tek076KildeTilKoordinatsaet
tek077KvalitetAfKoordinatsaet
tek078SupplerendeOplysningOmKoordinatsaet
tek101Gyldighedsdato
tek102FabrikatVindmoelle
tek103FabrikatOliefyr
tek104FabrikatSolcelleanlaegSolvarme
tek105OverdaekningTank
tek106InspektionsdatoTank
tek107PlaceringPaaSoeterritorie
tek109Koordinat { wkt }
tek110Driftstatus
tek111DatoForSenesteInspektion
tek112InspicerendeVirksomhed
tek500Notatlinjer
  `;
}


function gql(query: TemplateStringsArray): string {
  return query[0];
}